<script setup>
import { useI18n } from 'vue-i18n'
import LicenceExpiryPill from '@/Components/UI/LicenceExpiryPill.vue'

defineProps({ customer: { type: Object, required: true } })

const { t } = useI18n()
</script>

<template>
  <div class="space-y-2">
    <!-- Top row: name + rentals count -->
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0 flex-1">
        <div class="truncate text-[color:var(--ink)] font-medium">
          {{ customer.full_name || `${customer.first_name || ''} ${customer.last_name || ''}`.trim() || t('customers.card.unknown') }}
        </div>
        <a
          v-if="customer.phone"
          :href="`tel:${customer.phone}`"
          class="text-xs text-[color:var(--inkSoft)] tabular-nums"
          @click.stop
        >{{ customer.phone }}</a>
      </div>
      <div
        v-if="customer.rentals_count != null"
        class="shrink-0 text-right"
      >
        <div class="fw-value tabular-nums text-[color:var(--ink)]">
          {{ customer.rentals_count }}
        </div>
        <div class="mt-0.5 text-[10px] uppercase tracking-wide text-[color:var(--muted)]">
          {{ t('customers.card.rentals') }}
        </div>
      </div>
    </div>

    <!-- Email + licence -->
    <div class="flex items-center justify-between gap-3 text-xs">
      <span class="min-w-0 truncate text-[color:var(--muted)]">{{ customer.email || '—' }}</span>
      <LicenceExpiryPill
        v-if="customer.licence_expiry"
        :expires-at="customer.licence_expiry"
      />
    </div>
  </div>
</template>
